import type { StakeKind } from "@/lib/odds-screen/live/types";

export const EXCHANGE_BOOKS: ReadonlySet<string> = new Set(["novig", "prophetx", "fourcx", "fourcasters", "sxbet", "kalshi", "polymarket", "cryptocom"]);

export type Stake = { readonly usd: number; readonly kind: StakeKind };

export type StakeQuote = {
  readonly stake: Stake;
  readonly odds: number;
  readonly side: string | null;
  readonly other: string | null;
};

export function bookStake(book: string, usd: number | null): Stake | null {
  if (usd === null || !(Math.round(usd) > 0)) return null;
  return { usd, kind: EXCHANGE_BOOKS.has(book.toLowerCase()) ? "depth" : "limit" };
}
